import { type Option } from '@allesauto/core/searchDropdown';

import {
  DELETE_FILTER_MERCHANT_LOCATION,
  RESET_FILTER_MERCHANT_LOCATION,
  SET_FILTER_MERCHANT_LOCATION,
} from '@/store/redux/actions/pages/pcp/filters/merchantLocation';
import {
  deleteFromFilterArrayHandler,
  IReduxActionProps,
} from '@/store/redux/Utils';

export interface MerchantLocationFilterState {
  merchantLocation: string[];
}

export interface MerchantLocationFilterStateProps {
  merchantLocation: Option[];
}

export const InitialMerchantLocationFilterState: MerchantLocationFilterStateProps =
  {
    merchantLocation: [],
  };

const MerchantLocationState = (
  state: MerchantLocationFilterStateProps = InitialMerchantLocationFilterState,
  action: IReduxActionProps
) => {
  const value = action.payload as MerchantLocationFilterStateProps;
  switch (action.type) {
    case SET_FILTER_MERCHANT_LOCATION: {
      return {
        ...state,
        ...value,
      };
    }
    case DELETE_FILTER_MERCHANT_LOCATION: {
      return (
        action.payload && deleteFromFilterArrayHandler(state, action.payload)
      );
    }
    case RESET_FILTER_MERCHANT_LOCATION:
      return InitialMerchantLocationFilterState;
    default:
      return state;
  }
};

export default MerchantLocationState;
